<template>
    <div>
        <template v-if="props.model.Email == null">
            <div v-if="error">
                <p class="signup-error">Hmm... It looks like that email address hasn't been used to sign up for anything yet.</p>
            </div>
            <div v-else class="enter-email">
                <div class="mb-5">
                    <span class="h3">Already subscribed?</span>
                    <p>Enter your email address below and we'll send you a link to manage your email preferences.</p>
                    <form>
                        <div class="input-group">
                            <input type="email" class="form-control" placeholder="Email address" v-model="props.model.Email" />
                            <div class="input-group-append">
                                <button type="submit" class="btn btn-primary" @click.prevent="submitEmail">Manage</button>
                            </div>
                        </div>
                    </form>
                </div>

                <hr class="mb-5" />
            </div>
        </template>
        <template v-else>
            <div v-if="props.error">
                Error: {{ props.error }}
            </div>
            <div v-else>
                <h4>Manage Email Subscriptions for {{ props.model.Email }}</h4>
                <form>
                    <div class="mb-3">
                        <button type="button" class="btn btn-outline-primary me-1" @click="deselectAll">Deselect All</button>
                        <button type="button" class="btn btn-success me-1" v-show="dirty" @click="saveChanges">Save Changes</button>
                        <button type="button" class="btn btn-danger" v-show="dirty" @click="revert">Cancel</button>
                    </div>
                    <div class="checkbox" v-for="group in groups">
                        <label>
                            <input type="checkbox" v-model="group.IsSubscribed" :value="group.Id" />
                            {{ group.Name }}
                        </label>
                    </div>
                </form>
            </div>
        </template>
    </div>
</template>

<script setup>
    import { ref, computed } from "vue";

    const props = defineProps(["model", "error", "updateSubscriptionsUrl", "sendEmailUrl"]);

    const groups = ref(_.cloneDeep(props.model.Groups));
    const originalGroups = ref(_.cloneDeep(props.model.Groups));

    const dirty = computed(() => {
        return changed.value?.length > 0;
    });

    const changed = computed(() => {
        return _(groups.value)
            .filter((g, i) => g.IsSubscribed !== originalGroups.value[i].IsSubscribed)
            .map(g => ({
                group: g,
                added: g.IsSubscribed
            })).value();
    });

    const added = computed(() => {
        return _(changed.value)
            .filter(g => g.added)
            .map(g => g.group.Id)
            .value();
    });

    const removed = computed(() => {
        return _(changed.value)
            .filter(g => !g.added)
            .map(g => g.group.Id)
            .value();
    });

    function saveChanges() {
        Messenger().run({
            action: $.ajax,
            successMessage: "Subscription preferences have been updated.",
            errorMessage: "There was an error updating your subscription preferences.",
            progressMessage: "Updating..."
        },
            {
                method: "PUT",
                url: props.updateSubscriptionsUrl,
                data: {
                    Email: props.model.Email,
                    Added: added.value,
                    Removed: removed.value
                },
                success: function (data) {
                    originalGroups.value = _.cloneDeep(groups.value);
                }
            });
    }

    function revert() {
        groups.value = _.cloneDeep(originalGroups.value);
    }

    function deselectAll() {
        _.forEach(groups.value, g => {
            g.IsSubscribed = false;
        });
    }

    function submitEmail() {
        Messenger().run({
            action: $.ajax,
            successMessage: "An email has been sent to " + props.model.Email,
            errorMessage: "There was an error sending an email to " + props.model.Email,
            progressMessage: "Sending..."
        },
        {
            method: "POST",
            url: props.sendEmailUrl,
            data: {
                email: props.model.Email
            }
        });
    }
</script>